import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getGroupedReleaseVersionContributions,
  getRelease,
  getReleaseVersion,
  getVersionSyncStatus,
} from 'app/store/Releases/selectors';
import { ReleaseType } from 'types/releases';
import { fetchContributionClassesRolesDDLEffect } from 'app/store/SongList/effects';
import {
  syncVersionEffect,
  updateVersionCreditsEffect,
} from 'app/store/Releases/effects';
import { UpdateVersionCreditsEffectData } from 'app/store/Releases/effects.types';
import { useContributionRolesDDL } from 'app/utils/hooks';
import { VersionCreditsListComponent } from './VersionCreditsListComponent';

export const VersionCreditsList: React.FC = () => {
  const dispatch = useAppDispatch();
  const release = useAppSelector(getRelease);
  const credits = useAppSelector(getGroupedReleaseVersionContributions);
  const releaseVersion = useAppSelector(getReleaseVersion);
  const syncState = useAppSelector((state) =>
    getVersionSyncStatus(state, releaseVersion?.song.versionGuid || '')
  );
  const contributionRolesDDL = useContributionRolesDDL();

  useEffect(() => {
    const isContributionRolesDDLFetched =
      Object.keys(contributionRolesDDL).length > 0;
    if (!isContributionRolesDDLFetched) {
      dispatch(fetchContributionClassesRolesDDLEffect());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const syncCredits = async () => {
    if (releaseVersion) {
      const { song, metadata } = releaseVersion;
      await dispatch(
        syncVersionEffect({
          versionGuid: song.versionGuid,
          songGuid: metadata.songGuid,
        })
      );
    }
  };

  const updateCreditsList = async (data: UpdateVersionCreditsEffectData) => {
    await dispatch(updateVersionCreditsEffect(data));
  };

  return (
    <VersionCreditsListComponent
      credits={credits}
      rolesDDL={contributionRolesDDL}
      syncCredits={syncCredits}
      syncState={Boolean(syncState)}
      updateCreditsList={updateCreditsList}
      releaseType={release?.type as ReleaseType}
      validationErrors={releaseVersion?.validationErrors}
      loading={syncState}
    />
  );
};
